export const customColumnPath = (index, keyname, chIndex, chName) => {
  return {
    COMMONPATH: `columns[${index}][${keyname}]`,
    CALCULATION_DEFAULT_ARR: `columns[${index}].formulaArr`,
    COLUMNS_EACH_OBJECT: `columns[${index}]`,
    LABELCOLOURS_UPDATES: `columns[${index}].labelColoursOptions[${chIndex}][${chName}]`,
    STATUS_COLOURS: `columns[${index}].statusColoursOptions[${chIndex}][${chName}]`,
  };
};

export const calculationFormulaPath = (index, chIndex, keyname) => {
  return {
    FORMULA_OBJECT: `columns[${index}].formulaArr[${chIndex}][${keyname}]`,
    FORMULA_ARRAY: `columns[${index}].formulaArr`,
    FORMULA_STRING: `columns[${index}].formulaString`,
    READONLY_FORMULA_STRING: `columns[${index}].readOnlyFormulaString`,
  };
};

export const manualPath = (index, keyname, opInd) => {
  return {
    MANUAL_PATH: `columns[${index}][${keyname}]`,
    MANUAL_OPTIONS: `columns[${index}].options`,
    MANUAL_OPTIONS_OBJECT: `columns[${index}].options[${opInd}].name`,
    // MANUAL_NUMBER_OBJECT: `columns[${index}].numberValue`,
  };
};

export const sourcePath = (index, keyname) => {
  return {
    SOURCE_KEY_PATH: `columns[${index}].source[${keyname}]`,
  };
};

export const errorpath = (pindex, index, keyname) => {
  return {
    FORMULA_OBJECT_ERROR: `formulaArr[${pindex}][${index}][${keyname}]`,
    MANUAL_ERROR: `options[${pindex}][${index}].name`,
    SOURCE_ERROR: `source[${pindex}][${keyname}]`,
  };
};
